// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mq-6";
export var imgContainer = "_mq-3";
export var menuIcon = "_mq-5";
export var pillWrapper = "_mq-2";
export var pillsContainer = "_mq-1";
export var subscriptionCard = "_mq-0";
export var subscriptionLogo = "_mq-4";